((globalScope, factory) => {
  const api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (globalScope) globalScope.BPBeautyVesConciergeCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  const PATHS = Object.freeze(['makeup', 'skincare']);
  const ANALYTICS_KEYS = Object.freeze([
    'path',
    'result_key',
    'product_handle',
    'variant_id',
    'item_count',
    'source',
    'error_code',
  ]);

  const positiveInteger = (value) => {
    const number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
  };

  const variantId = (value) => {
    const normalized = String(value ?? '').trim();
    return /^\d+$/.test(normalized) && normalized !== '0' ? normalized : null;
  };

  const validateRoutine = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) {
      return { valid: false, code: 'missing_product', index: -1 };
    }

    for (let index = 0; index < items.length; index += 1) {
      const item = items[index] || {};
      if (!item.productHandle) return { valid: false, code: 'missing_product', index };
      if (!item.productAvailable) return { valid: false, code: 'sold_out', index };
      if (!variantId(item.variantId)) return { valid: false, code: 'missing_variant', index };
      if (!item.variantAvailable) return { valid: false, code: 'sold_out', index };
      if (!positiveInteger(item.priceCents)) return { valid: false, code: 'missing_price', index };
    }

    return { valid: true, code: null, index: -1 };
  };

  const calculateTotal = (items = []) => items.reduce(
    (total, item) => total + (positiveInteger(item?.priceCents) || 0),
    0,
  );

  const buildCartLines = (items = []) => items.map((item) => ({
    id: variantId(item.variantId),
    quantity: 1,
  }));

  const classifyCartError = (status, payload = {}) => {
    const message = `${payload.description || ''} ${payload.message || ''} ${payload.errors || ''}`.toLowerCase();
    if (status === 422 || message.includes('sold out') || message.includes('esaurit') || message.includes('unavailable')) {
      return 'sold_out';
    }
    if (status === 401 || status === 403) return 'session_error';
    if (status >= 400) return 'cart_error';
    return 'unknown_error';
  };

  const filterAnalyticsPayload = (payload = {}) => Object.fromEntries(
    Object.entries(payload).filter(
      ([key, value]) => ANALYTICS_KEYS.includes(key) && value !== '' && value !== null && value !== undefined,
    ),
  );

  const createSubmissionGate = () => {
    let pending = false;
    return Object.freeze({
      get pending() {
        return pending;
      },
      async run(task) {
        if (pending) return { skipped: true };
        pending = true;
        try {
          return await task();
        } finally {
          pending = false;
        }
      },
    });
  };

  return Object.freeze({
    ANALYTICS_KEYS,
    PATHS,
    buildCartLines,
    calculateTotal,
    classifyCartError,
    createSubmissionGate,
    filterAnalyticsPayload,
    positiveInteger,
    variantId,
    validateRoutine,
  });
});
